import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import es from './locales/es.json';
import pt from './locales/pt.json';

export const SUPPORTED_LANGUAGES = ['en', 'es', 'pt'];
export const LANGUAGE_STORAGE_KEY = 'paltalabs-lang';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      pt: { translation: pt },
    },
    supportedLngs: SUPPORTED_LANGUAGES,
    fallbackLng: 'en',
    // Collapse regional variants: es-CL -> es, pt-BR -> pt, en-GB -> en.
    load: 'languageOnly',
    detection: {
      // A stored choice always beats the browser setting.
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
    },
    // React escapes interpolated values already.
    interpolation: { escapeValue: false },
  });

/** Assistive tech and crawlers read the active language off <html lang>. */
const syncDocumentLanguage = (language) => {
  document.documentElement.lang = language;
};

syncDocumentLanguage(i18n.resolvedLanguage);
i18n.on('languageChanged', syncDocumentLanguage);

export default i18n;
